import { Skeleton } from '@mui/material';

import styles from '@forms/Appointment/Form.module.css';

/**
 *  Form component detailing the Scheduled Pickup/Delivery DateTime
 */
export default function UpdateScheduledFormSkeleton() {
	return (
		<>
			<fieldset className={styles.fieldset}>
				<legend className={styles.legend}>Pickup</legend>
				<Skeleton
					width={360}
					height={110}
					variant='rounded'
				/>
			</fieldset>
			<fieldset className={styles.fieldset}>
				<legend className={styles.legend}>Delivery</legend>
				<Skeleton
					width={360}
					height={110}
					variant='rounded'
				/>
			</fieldset>
		</>
	);
}
